import { useUBLContext, ZigzagEvent } from '@common/log-manager';

export const useProductOptionLog = () => {
  const ublContext = useUBLContext();

  const impressOptionUBL = (
    object_id: string,
    catalog_product_id: string,
    general_product_id: string | null,
    zonly_product_id: string | null,
  ) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      object_type: 'button',
      object_id,
      object_section: 'option_value',
      data: JSON.stringify({
        catalog_product_id,
        ...(general_product_id && { general_product_id }),
        ...(zonly_product_id && { zonly_product_id }),
      }),
    });
  };

  const impressSoldOutUBL = (catalog_product_id: string, value: string) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      object_type: 'button',
      object_id: 'restock_noti',
      data: JSON.stringify({
        catalog_product_id,
        product_option: value,
      }),
    });
  };

  const impressGeneralProductLandingLinkUBL = (catalog_product_id: string, general_product_id?: string | null) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      object_type: 'button',
      object_id: 'move_to_browser',
      data: JSON.stringify({
        catalog_product_id,
        ...(general_product_id && { general_product_id }),
      }),
    });
  };

  const clickSoldOutViewMoreUBL = (catalog_product_id: string, value: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      object_type: 'button',
      object_id: 'restock_option',
      data: JSON.stringify({
        catalog_product_id,
        product_option: value,
      }),
    });
  };

  const clickGeneralProductLandingLinkUBL = (catalog_product_id: string, general_product_id?: string | null) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      object_type: 'button',
      object_id: 'move_to_browser',
      data: JSON.stringify({
        catalog_product_id,
        ...(general_product_id && { general_product_id }),
      }),
    });
  };

  const clickOptionUBL = (
    object_id: string,
    catalog_product_id: string,
    general_product_id?: string | null,
    zonly_product_id?: string | null,
  ) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      object_type: 'button',
      object_id,
      object_section: 'option_value',
      data: JSON.stringify({
        catalog_product_id,
        ...(general_product_id && { general_product_id }),
        ...(zonly_product_id && { zonly_product_id }),
      }),
    });
  };

  return {
    impressSoldOutUBL,
    impressGeneralProductLandingLinkUBL,
    impressOptionUBL,
    clickGeneralProductLandingLinkUBL,
    clickSoldOutViewMoreUBL,
    clickOptionUBL,
  };
};
